import Vue from 'vue';
import Router from 'vue-router';

import { dynamicImportViewsByDeviceWidth } from '../utils/dynamicImport';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.NODE_ENV === 'production' ? '/tracker/' : '/',
	routes: [
		{
			path: '/',
			name: 'Home',
			component:() => dynamicImportViewsByDeviceWidth('/Home/HomePc','/Home/HomeMobile')
		},
		{
			path:'/Agreement',
			name: 'Terms',
			component: () => dynamicImportViewsByDeviceWidth('/Terms/AgreementPC','/Terms/AgreementMobile')
		}
	],
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 };
	}
});
